/**
 * NOGOOD-RACING Shopify Top Page helpers
 * - Language toggle (JP/EN) using .jp / .en + .show
 * - Hero video sound toggle for currently visible video (pc/sp)
 * - Scroll reveal animations: adds .is-visible to .js-revealInView and .top-team__itemImage when in view
 * - Top Insights slider: initializes Splide on .top-insights__slide.splide (ul.top-insights__list)
 *
 * Notes:
 * - CSS expects `.top-section-heading.is-visible .top-section-heading__text { ... }`
 * - CSS expects `.top-team__itemImage.is-visible img { clip-path: ... }`
 */
(function () {
  "use strict";

  var SPLIDE_SRC = "https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js";

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // --- Language toggle (JP/EN) ---
  function applyLanguageShow(root) {
    var checked = qs('input[type="radio"].btn_lang:checked', root);
    if (!checked) return;

    qsa(".jp, .en", root).forEach(function (el) {
      el.classList.remove("show");
    });

    if (checked.id === "jp") {
      qsa(".jp", root).forEach(function (el) { el.classList.add("show"); });
    } else {
      qsa(".en", root).forEach(function (el) { el.classList.add("show"); });
    }
  }

  function initLanguageToggle(root) {
    var radios = qsa('input[type="radio"].btn_lang', root);
    if (!radios.length) return;

    // initial
    applyLanguageShow(document);

    radios.forEach(function (r) {
      r.addEventListener("change", function () {
        applyLanguageShow(document);
      });
    });
  }

  // --- Hero sound toggle ---
  function getVisibleVideo(wrap) {
    if (!wrap) return null;
    // prefer visible one by CSS (u-pc / u-sp). If both exist, choose the one currently displayed.
    var vids = qsa("video", wrap);
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var style = window.getComputedStyle(v);
      if (style && style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0") {
        return v;
      }
    }
    return vids[0] || null;
  }

  function syncSoundButton(btn, isMuted, offSrc, onSrc) {
    if (!btn) return;
    var img = qs("img", btn);
    if (!img) return;
    img.src = isMuted ? offSrc : onSrc;
    img.alt = isMuted ? "sound off" : "sound on";
    btn.setAttribute("aria-pressed", isMuted ? "false" : "true");
  }

  function initHeroSoundToggle(root) {
    qsa(".js-sound-toggle", root).forEach(function (button) {
      if (button.__nogoodBound) return;
      button.__nogoodBound = true;

      var wrap = button.closest(".top-hero, .hero, body") || document.body;

      var offSrc = button.getAttribute("data-off") || "";
      var onSrc = button.getAttribute("data-on") || "";

      // initial state
      var v0 = getVisibleVideo(wrap);
      if (v0) syncSoundButton(button, v0.muted, offSrc, onSrc);

      button.addEventListener("click", function () {
        var v = getVisibleVideo(wrap);
        if (!v) return;
        v.muted = !v.muted;
        syncSoundButton(button, v.muted, offSrc, onSrc);
      });
    });
  }

  // --- Scroll reveal ---
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function parseRootMargin(el) {
    // original markup uses data-root-margin="-15% 0%"
    var rm = el.getAttribute("data-root-margin") || el.dataset.rootMargin || "";
    return rm || "0px 0px -15% 0px";
  }

function setTopTeamStaggerDelays(root) {
  var items = qsa(".top-team__list .top-team__itemImage", root);
  if (!items.length) return;

  // Matches CSS grid: desktop 3 cols, mobile 2 cols
  var isMobile = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  var cols = isMobile ? 2 : 3;

  // Delay step tuned to feel like original stagger
  var step = isMobile ? 0.08 : 0.12;

  items.forEach(function (wrap, idx) {
    var col = idx % cols;
    var delay = col * step;

    // Apply to the <img> because CSS transitions live there
    var img = qs("img", wrap);
    if (img) {
      img.style.transitionDelay = delay.toFixed(2) + "s";
    }
  });
}



  

  function getGridColumnCount(listEl) {
    if (!listEl || !window.getComputedStyle) return 3;
    var cols = window.getComputedStyle(listEl).gridTemplateColumns || "";
    // normalize multiple spaces
    var parts = cols.split(" ").filter(function (p) { return p && p !== "/"; });
    return parts.length || 3;
  }

  function applyTopTeamStaggerDelay(target) {
    // target may be the wrapper (.top-team__itemImage) or any descendant
    var wrap = target && target.classList && target.classList.contains("top-team__itemImage")
      ? target
      : (target && target.closest ? target.closest(".top-team__itemImage") : null);

    if (!wrap) return;

    var list = wrap.closest ? wrap.closest(".top-team__list") : null;
    var li = wrap.closest ? wrap.closest("li") : null;
    if (!list || !li) return;

    // Determine index among LI children
    var children = Array.prototype.filter.call(list.children, function (n) {
      return n && n.tagName === "LI";
    });
    var idx = children.indexOf(li);
    if (idx < 0) return;

    var isMobile = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
    var cols = getGridColumnCount(list) || (isMobile ? 2 : 3);

    // Step tuned to feel like original (slightly faster on dense grids)
    var step = isMobile ? 0.08 : (cols >= 4 ? 0.08 : 0.12);
    var col = idx % cols;
    var delay = col * step;

    var img = qs("img", wrap);
    if (img) {
      img.style.transitionDelay = delay.toFixed(3) + "s";
    }
  }

function initRevealInView(root) {
    // Stagger reveal for the TOP "ITEMS" grid
    setTopTeamStaggerDelays(root);
    var targets = []
      .concat(qsa(".js-revealInView", root))
      .concat(qsa(".top-team__itemImage", root));

    if (!targets.length) return;

    // Reduced motion: show immediately
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }

    // group by rootMargin so we can reuse observers
    var groups = new Map();
    targets.forEach(function (el) {
      // skip if already visible or already observed
      if (el.classList.contains("is-visible")) return;
      if (el.__nogoodObserved) return;
      el.__nogoodObserved = true;

      var rm = parseRootMargin(el);
      if (!groups.has(rm)) groups.set(rm, []);
      groups.get(rm).push(el);
    });

    groups.forEach(function (els, rm) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          // Apply TOP TEAM stagger delay (left->right per row) BEFORE revealing
          applyTopTeamStaggerDelay(entry.target);

          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        });
      }, { root: null, rootMargin: rm, threshold: 0.01 });

      els.forEach(function (el) { io.observe(el); });
    });
  }



  // --- Section parallax (.js-sectionParallax) ---
  var __nogoodParallaxBound = false;
  var __nogoodParallaxEls = [];
  var __nogoodParallaxRaf = null;

  function initSectionParallax(root) {
    var els = qsa(".js-sectionParallax", root || document);
    if (!els.length) return;

    els.forEach(function (el) {
      if (el.__nogoodParallax) return;
      el.__nogoodParallax = true;
      el.__nogoodParallaxBaseTransform = el.style.transform || "";
      __nogoodParallaxEls.push(el);
    });

    function update() {
      __nogoodParallaxRaf = null;
      var vh = window.innerHeight || 800;
      var max = 0.30 * vh; // 30vh -> px
      __nogoodParallaxEls = __nogoodParallaxEls.filter(function (el) {
        return el && document.documentElement.contains(el);
      });

      __nogoodParallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var y = rect.top; // element top relative to viewport
        // start when top hits bottom (y = vh), end when top hits top (y = 0)
        var progress = (vh - y) / vh;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var translate = (1 - progress) * max;

        // will-change only while in range
        el.style.willChange = (progress > 0 && progress < 1) ? "transform" : "auto";

        var base = el.__nogoodParallaxBaseTransform || "";
        var t = "translate3d(0," + translate.toFixed(2) + "px,0)";
        el.style.transform = base ? (base + " " + t) : t;
      });
    }

    function requestUpdate() {
      if (__nogoodParallaxRaf) return;
      __nogoodParallaxRaf = window.requestAnimationFrame(update);
    }

    if (!__nogoodParallaxBound) {
      __nogoodParallaxBound = true;
      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate);
    }

    requestUpdate();
  }

  // --- Splide loader + init ---
  function loadScriptOnce(src, id) {
    return new Promise(function (resolve, reject) {
      if (id && document.getElementById(id)) {
        resolve();
        return;
      }
      var s = document.createElement("script");
      if (id) s.id = id;
      s.src = src;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error("Failed to load script: " + src)); };
      document.head.appendChild(s);
    });
  }

  function initTopInsightsSplide(root) {
    var el = qs(".top-insights__slide.splide", root) || qs(".js-topInvesteesInsights.splide", root);
    if (!el) return;

    // prevent double init (theme editor / section reload)
    if (el.__nogoodSplide) return;

    function mountSplide() {
      if (!window.Splide) return;

      // Active slide scaling (center slightly larger like original)
      var styleId = "nogood-insights-active-scale";
      if (!document.getElementById(styleId)) {
        var st = document.createElement("style");
        st.id = styleId;
        st.textContent = [
          ".top-insights__slide .splide__slide .top-insight-card{transform:scale(0.9);}",
          ".top-insights__slide .splide__slide.is-active .top-insight-card{transform:scale(1);}"
        ].join("\n");
        document.head.appendChild(st);
      }

      // If markup has a specific id (e.g. splide02) keep it. Splide accepts element reference.
      var splide = new window.Splide(el, {
        type: "loop",
        drag: "free",
        snap: true,

        // Show partial slides on both sides (center focus)
        focus: "center",
        perPage: 1.5,
        gap: "2vw",
        padding: "7vw",

        easing: "cubic-bezier(0.76, 0, 0.24, 1)",
        arrows: false,
        pagination: true,

        autoplay: true,
        interval: 4500,
        speed: 1000,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: false,

        rewind: false,
        waitForTransition: true,
        updateOnMove: true,

        breakpoints: {
          767: {
            // SP: 1.5 slides (center + partials)
            focus: "center",
            perPage: 1,
            gap: "4vw",
            padding: "17%",
            easing: "cubic-bezier(0.25, 1, 0.5, 1)"
          }
        }
      });

      splide.mount();
      el.__nogoodSplide = splide;
    }

    if (window.Splide) {
      mountSplide();
      return;
    }

    loadScriptOnce(SPLIDE_SRC, "nogood-splide-lib")
      .then(function () { mountSplide(); })
      .catch(function () {
        // If Splide can't be loaded, do nothing (content still shows as list)
      });
  }

  function initAll(root) {
    // root may be a section container; but language toggle is global.
    initLanguageToggle(document);
    initHeroSoundToggle(root || document);
    initRevealInView(root || document);
    initSectionParallax(root || document);
    initTopInsightsSplide(root || document);
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  // Theme editor: re-init when the section is reloaded
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });


// Recompute stagger delays on resize (once)
if (!window.__nogoodTopResizeBound) {
  window.__nogoodTopResizeBound = true;
  var __nogoodResizeTimer = null;
  window.addEventListener("resize", function () {
    if (__nogoodResizeTimer) clearTimeout(__nogoodResizeTimer);
    __nogoodResizeTimer = setTimeout(function () {
      setTopTeamStaggerDelays(document);
    }, 200);
  });
}

})();
